// extracted by mini-css-extract-plugin
export default {"container":"index_container__-v3x1","spin":"index_spin__WJcG0"};